<eess-bienvenido></eess-bienvenido>
<div class="row d-flex jc-c loading-component">
    <div class="bch-card col-11 col-md-9 col-lg-7 col-xl-8 pt-0 pl-0 pr-0">
        <div class="header">
            <mat-progress-bar class="audio-progress-bar" mode="indeterminate"></mat-progress-bar>
        </div>
        <div class="body pa-4">
            <div class="d-flex jc-c">
                <img class="" src="assets/images/progreso.svg">
            </div>
            <div class="card-body">
                <div class="ta-c">
                    <h3 class="c-primary">Estamos identificando tus datos</h3>
                </div>
                <div class="ta-c">
                    <p><b>Danos unos segundos</b> para continuar con el proceso.</p>
                </div>
            </div>
        </div>
    </div>
</div>